// @ts-nocheck

(function () {
  "use strict";

  const KEY = "breadcrumb_page_path";
  const path = window.location.pathname;

  const DRILL_BIT_FINDER_PARENT = "/pages/drill-bit-finder";
  const LEVEL_1_PAGES = ["/pages/cutting", "/pages/drilling", "/pages/grinding"];

  function isDrillBitFinderPage(currentPath) {
    if (currentPath === DRILL_BIT_FINDER_PARENT) return true;
    return LEVEL_1_PAGES.some(page => currentPath === page || currentPath.startsWith(page + "-"));
  }

  // Get level 1 parent for a level 2 page
  function getLevel1Parent(currentPath) {
    for (const level1 of LEVEL_1_PAGES) {
      if (currentPath.startsWith(level1 + "-")) {
        return level1;
      }
    }
    return null;
  }

  if (!isDrillBitFinderPage(path)) {
    sessionStorage.removeItem(KEY);
    return;
  }

  function save() {
    try {
      const h1 = document.querySelector("h1");
      let title = h1?.textContent?.trim() || "";
      
      if (!title) {
        const pathParts = path.split("/").pop();
        title = pathParts?.replace(/-/g, " ") || "";
      }

      const url = path;
      let level1Parent = null;

      if (path !== DRILL_BIT_FINDER_PARENT && !LEVEL_1_PAGES.includes(path)) {
        level1Parent = getLevel1Parent(path);
      }

      let history = [];
      try {
        history = JSON.parse(sessionStorage.getItem(KEY) || "[]");
        if (!Array.isArray(history)) history = [];
      } catch (e) {
        history = [];
      }

      history = history.filter(item => item.url !== url);

      const pageData = { url, title, level1Parent };
      history.push(pageData);

      if (history.length > 2) history = history.slice(-2);

      sessionStorage.setItem(KEY, JSON.stringify(history));
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", save);
  } else {
    save();
  }
})();
